import { render, staticRenderFns } from "./DashboardChartPatients.vue?vue&type=template&id=9d17b2d6&scoped=true&"
import script from "./DashboardChartPatients.vue?vue&type=script&lang=js&"
export * from "./DashboardChartPatients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d17b2d6",
  null
  
)

export default component.exports